import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from "react";
import { InlineEdit as RSInlineEdit } from "rsuite";
import { Toaster, Message } from "../index";
function InlineEdit({ title, onSave, onChange }) {
    const [editedTitle, setEditedTitle] = useState(title);
    const [prevTitle, setPrevTitle] = useState(title);
    const [errorMessage, setErrorMessage] = useState("");
    const toaster = Toaster();
    const toastMessage = (_jsx(Message, { children: "Title cannot be blank.", type: "error", showIcon: true, closable: true, styles: { marginTop: "5px" } }));
    // Handles the save action
    const handleSave = () => {
        if (editedTitle.trim() === "") {
            toaster.push(toastMessage, {
                placement: "topCenter",
                duration: 5000,
            });
            setEditedTitle(prevTitle);
            return;
        }
        onSave?.(editedTitle);
    };
    return (_jsx("div", { children: _jsx(RSInlineEdit, { showControls: false, className: "inline-edit", value: editedTitle, onChange: (newValue) => {
                errorMessage && setErrorMessage("");
                setEditedTitle(newValue);
                onChange?.(newValue);
            }, onSave: handleSave, onEdit: () => setPrevTitle(editedTitle), onCancel: () => setEditedTitle(prevTitle) }) }));
}
export default InlineEdit;
